// 组件对象，大写
import proportionWithUnit from './proportionWithUnit.vue'
export default proportionWithUnit
